import { PermissionTarget } from "../Auth/permissionTargets.js"

export const PERSON_CREDITS_IMPORT_SOURCE_PERMISSIONS = {
	cast: {
		tmdb: PermissionTarget.IMPORT_WIZARD_CASTING_TMDB,
		omdb: PermissionTarget.IMPORT_WIZARD_CASTING_OMDB,
		wikipedia: PermissionTarget.IMPORT_WIZARD_CASTING_WIKIPEDIA,
		image: PermissionTarget.IMPORT_WIZARD_CASTING_IMAGE,
		text: PermissionTarget.IMPORT_WIZARD_CASTING_TEXT,
		pdf: PermissionTarget.IMPORT_WIZARD_CASTING_PDF,
	},
	crew: {
		tmdb: PermissionTarget.IMPORT_WIZARD_CREDITS_TMDB,
		omdb: PermissionTarget.IMPORT_WIZARD_CREDITS_OMDB,
		wikipedia: PermissionTarget.IMPORT_WIZARD_CREDITS_WIKIPEDIA,
		image: PermissionTarget.IMPORT_WIZARD_CREDITS_IMAGE,
		text: PermissionTarget.IMPORT_WIZARD_CREDITS_TEXT,
		pdf: PermissionTarget.IMPORT_WIZARD_CREDITS_PDF,
	},
} as const satisfies Record<string, Record<string, PermissionTarget>>

export const PERSON_IMAGES_IMPORT_SOURCE_PERMISSIONS = {
	tmdb: PermissionTarget.IMPORT_WIZARD_PERSON_TMDB,
	"wikimedia-commons": PermissionTarget.IMPORT_WIZARD_PERSON_WIKIMEDIA_COMMONS,
	wikidata: PermissionTarget.IMPORT_WIZARD_PERSON_WIKIDATA,
	bestimage: PermissionTarget.IMPORT_WIZARD_PERSON_BESTIMAGE,
} as const satisfies Record<string, PermissionTarget>

export type PersonCreditsImportPermissionSection = keyof typeof PERSON_CREDITS_IMPORT_SOURCE_PERMISSIONS
export type PersonCreditsImportPermissionSource = keyof (typeof PERSON_CREDITS_IMPORT_SOURCE_PERMISSIONS)["cast"]
export type PersonImagesImportPermissionSource = keyof typeof PERSON_IMAGES_IMPORT_SOURCE_PERMISSIONS

export const isPersonCreditsImportPermissionSource = (source: string): source is PersonCreditsImportPermissionSource =>
	Object.hasOwn(PERSON_CREDITS_IMPORT_SOURCE_PERMISSIONS.cast, source)

export const isPersonImagesImportPermissionSource = (source: string): source is PersonImagesImportPermissionSource =>
	Object.hasOwn(PERSON_IMAGES_IMPORT_SOURCE_PERMISSIONS, source)
